module.exports = __webpack_public_path__ + "static/5-3798154ec8ee1eda6c06951ce5d2707e.jpg";